export default "__VITE_ASSET__jp_QrdIY__"